import type { ReactNode } from 'react';

type StandardPageHeaderProps = {
  title: ReactNode;
  subtitle: ReactNode;
  titleAccessory?: ReactNode;
  actions?: ReactNode;
  className?: string;
  dataTourTarget?: string;
  showDivider?: boolean;
};

/** Calendar-derived title/subtitle geometry for standard desktop pages. */
export default function StandardPageHeader({ title, subtitle, titleAccessory, actions, className = '', dataTourTarget, showDivider = true }: StandardPageHeaderProps) {
  return (
    <div className="w-full">
      <header className={`mt-4 flex items-start justify-between ${className}`} data-tour-target={dataTourTarget}>
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="text-3xl font-bold">{title}</h1>
            {titleAccessory}
          </div>
          <p className="mt-1 mb-0 text-sm text-zinc-500 dark:text-zinc-400">{subtitle}</p>
        </div>
        {actions}
      </header>
      {showDivider && <div className="w-full h-px bg-zinc-600/60 dark:bg-zinc-500/30 mt-2 mb-6" />}
    </div>
  );
}
